import { OnboardingProgressDto, OnboardingStepAnswerDto } from '../user/userApi';

export type OnboardingProgress = OnboardingProgressDto;
export type OnboardingStepAnswer = OnboardingStepAnswerDto;

export const ONBOARDING_STEP_REFERRER = 'referrer';
export const ONBOARDING_STEP_INDUSTRY = 'industry';
export const ONBOARDING_STEP_GOAL = 'goal';
export const ONBOARDING_STEP_VARIABLES = 'variables';
export const ONBOARDING_STEP_PROMPT = 'prompt';
export const ONBOARDING_STEP_END = 'end';
export const ONBOARDING_STEP_LAST = ONBOARDING_STEP_PROMPT;

export const ONBOARDING_STEPS: OnboardingStep[] = [
  ONBOARDING_STEP_REFERRER,
  ONBOARDING_STEP_INDUSTRY,
  ONBOARDING_STEP_GOAL,
  ONBOARDING_STEP_VARIABLES,
  ONBOARDING_STEP_PROMPT,
  ONBOARDING_STEP_END,
];
export type OnboardingStep =
  | typeof ONBOARDING_STEP_REFERRER
  | typeof ONBOARDING_STEP_INDUSTRY
  | typeof ONBOARDING_STEP_GOAL
  | typeof ONBOARDING_STEP_VARIABLES
  | typeof ONBOARDING_STEP_PROMPT
  | typeof ONBOARDING_STEP_END;
